import mapSceneToComponent from '../mapSceneToComponent.js'
import script from './networkers.json'
import { daisysHouse, factoryInside } from '../locations.js'

export const Scene = (scene) => () => {
  return (
    <>
      {scene.map(mapSceneToComponent)}
    </>
  )
}

const scenes = script.scenes

// Generated from Networkers_message_and_map_v6.docx (script_stuff/POSTGRAD game files) by the
// script-to-stories skill. Location names in the v6 docx are canonical; each
// path maps 'Theater' to its own factory* constant so markers from parallel
// paths don't stack. 'DIRECT' / 'NONE' entries are null.
const conversations = [
  {
    from: 'Daisy',
    messages: [
      { text: 'Come over, I want to show you this game I found (and I promise I won\'t ask if you have confirmed your topic).', isFromMe: false },
      { text: 'I\'ll call you later', isFromMe: true },
      { text: 'Why?', isFromMe: false },
      { text: 'OK. Good point.', isFromMe: true }
    ]
  },
  {
    from: 'Daisy',
    messages: [
      { text: 'Want to talk me through your topic? Even though it\'s only at master\'s level, it is pretty esoteric and hard to digest for a non-science student.', isFromMe: false },
      { text: '_Just_ a master\'s?', isFromMe: true },
      { text: 'I thought you\'d like that.', isFromMe: false },
      { text: 'I did.', isFromMe: true },
      { text: 'Call me when you\'re free', isFromMe: false }
    ]
  },
  {
    from: 'Daisy',
    messages: [
      { text: 'Come over, I want to ask you a couple of things about your topic.', isFromMe: false },
      { text: 'I\'ll bring some of the new NFP mint flavour. I\'ve pretty much finished the recipe and everything.', isFromMe: true },
      { text: 'Safe to drink?', isFromMe: false },
      { text: 'Safer than a Red Bull', isFromMe: true }
    ]
  },
  {
    from: 'Daisy',
    messages: [
      { text: 'Come over. I want to know why this is a network not just an online shop.', isFromMe: false }
    ]
  },
  {
    from: 'Daisy',
    messages: [
      { text: 'I don\'t think you should do this by yourself. You need another person, just for safety, if nothing else.', isFromMe: false },
      { text: 'I will be fine', isFromMe: true },
      { text: 'I know you think that but it will weigh on my mind if I know you are out there doing this stuff.', isFromMe: false },
      { text: 'It would weigh on my mind if you were helping me do this stuff.', isFromMe: true },
      { text: 'Talk IRL', isFromMe: false }
    ]
  },
  {
    from: 'Daisy',
    messages: [
      { text: 'Do you still have that kg of cayenne pepper in the pantry from last year?', isFromMe: true },
      { text: 'Yes, why?', isFromMe: false },
      { text: 'When you come over, can you please bring it?', isFromMe: true }
    ]
  },
  {
    from: 'Daisy',
    messages: [
      { text: 'When do you want to do the dress rehearsal?', isFromMe: false },
      { text: 'Any night I guess.', isFromMe: true },
      { text: 'Well, let\'s do it then.', isFromMe: false }
    ]
  },
  null // DIRECT
]

const markers = [
  { location: daisysHouse, text: 'Go see Daisy after dinner, once she gets up.' }, // docx loc: 'Daisy's house'
  { location: factoryInside, text: 'Talk about thesis with Daisy.' }, // docx loc: 'Theater'
  { location: daisysHouse, text: 'Tell Daisy about biotics deals.' }, // docx loc: 'Daisy's house'
  { location: daisysHouse, text: 'Tell Daisy about taking a dose' }, // docx loc: 'Daisy's house'
  { location: factoryInside, text: 'Daisy as conspirator?' }, // docx loc: 'Theater'
  { location: factoryInside, text: 'How to keep Daisy safe' }, // docx loc: 'Theater'
  { location: factoryInside, text: 'Dress rehearsal' }, // docx loc: 'Theater'
  null // DIRECT
]

const teasers = [
  'Bel\'s thesis is on biotic enhancements?',
  'So, biotics actually work?',
  'So people are infecting themselves?',
  'How to get access to the secure network.',
  'A safety plan?',
  'You can\'t kill someone with pepper, right?',
  null, // DIRECT
  'END of Chapter One.'
]


const art = [
  { url: '/networkers/scene1.png' },
  { url: '/networkers/scene2.png' },
  { url: '/networkers/scene3.png' },
  { url: '/networkers/scene4.png' },
  { url: '/networkers/scene5.png' },
  { url: '/networkers/scene6.png' },
  { url: '/networkers/scene7.png' },
  { url: '/networkers/scene8.png' }
]

// AUTO-GENERATED by scripts/deriveTimesOfDay.js — do not hand-edit; rerun `npm run derive-times-of-day` instead.
// Derived from each scene's opening SceneHeading in networkers.json.
// (DAY -> afternoon, MORNING -> morning, EVENING -> evening, NIGHT -> evening;
// a CONTINUOUS/LATER opening heading inherits the previous scene's slot.)
const timesOfDay = [
  'evening', // 0: EXT. A TIDY LITTLE BLUE HOUSE - NIGHT
  'evening', // 1: INT. BEL'S THEATER BEDROOM - NIGHT
  'evening', // 2: INT. DAISY'S LOUNGE - NIGHT
  'evening', // 3: INT. DAISY'S LOUNGE - NIGHT
  'evening', // 4: INT. BEL'S THEATER BEDROOM - NIGHT
  'evening', // 5: INT. THEATER LOBBY - NIGHT
  'evening', // 6: INT. TINY CAR - NIGHT
  'evening', // 7:  (inherited)
]

const stories = scenes.map((scene, i) => ({
  timeOfDay: timesOfDay[i],
  sceneArt: art[i],
  scene,
  conversation: conversations[i] || undefined,
  marker: markers[i] || undefined,
  teaser: teasers[i] || undefined
}))

export default stories
